export const TESTIMONIALS_COACH = [
  {
    description: 'I highly recommend Josh for his success mindset training as well as his ability to connect with vast audiences.',
    nameCoach: 'Josh Brecheisen',
    descriptionCoach: 'Career Coaching',
    imageCoach: 'joshbrecheisen.jpeg',
  },
  {
    description: 'Bob has provided invaluable coaching, advice, and immediately applicable tactics to aid my growth as an IT leader.',
    nameCoach: 'Bob Kantor',
    descriptionCoach: 'Executive Coach',
    imageCoach: 'bobkantor.jpg',
  },
  {
    description: "I've been able to advance my career as well as deal with organizational/personnel issues in particular roles. I highly recommend Kathy for teams and organizations as well as personal coaching.",
    nameCoach: 'Kathy Kersten',
    descriptionCoach: 'Career Coach',
    imageCoach: 'kathykersten.jpg',
  },
  {
    description: 'Erin did an amazing job of helping me discover my strengths and how to use those to accelerate at my job. She also taught me how to use those to interact with my clients and others around me.',
    nameCoach: 'Erin Bentley',
    descriptionCoach: 'Career Coach',
    imageCoach: 'erinbentley.jpeg',
  },
  {
    description: 'Mrs. Tabibian was a godsend who helped me identify my passion and instructed me how to guide this passion in the career choice that I am involved in today',
    nameCoach: 'Ellie Tabibian',
    descriptionCoach: 'Career Coach',
    imageCoach: 'ellietabibian.jpg',
  },
  {
    description: 'Consuela is a true coaching professional. She introduced a new program for S.C. Johnson. This new program taught our employees how to use our Strengths!',
    nameCoach: 'Consuela Munoz',
    descriptionCoach: 'Executive Coaching',
    imageCoach: 'consuelamunoz.jpg',
  },
  {
    description: "Every conversation has led to my 'seeing' something I hadn't seen before and has inspired me to take immediate action on some aspect of my life and business.",
    nameCoach: 'Jennifer Vancil',
    descriptionCoach: 'Career Coach',
    imageCoach: 'jennifervancil.jpg',
  },
  {
    description: 'Ed helped me build a stronger relationship with my son by showing me how to reach the heart of my child. Ed has a gift in teaching others who care for kids to be a great coach to their own kids.',
    nameCoach: 'Ed Miller',
    descriptionCoach: 'Family Coach',
    imageCoach: 'edmiller.jpg',
  },
  {
    description: 'Jill was instrumental in every step of crafting my TEDx talk: from finding the big idea, to making a sharp script, to delivering a compelling narrative with passion to grab the audience.',
    nameCoach: 'Jill Wesley',
    descriptionCoach: 'Speaking Coach',
    imageCoach: 'jillwesley.jpg',
  },
  {
    description: 'Michael is one of the best coaches in the world! He masterfully integrates powerful questions with poignant advice that leaves inspired and challenged at the same time',
    nameCoach: 'Michael Dauphinee',
    descriptionCoach: 'Career Coach',
    imageCoach: 'michaeldauphinee.jpg',
  },
];
